document.addEventListener("DOMContentLoaded", function () {
    const points = document.querySelectorAll(".bod");
    const detailBox = document.querySelector(".bod-detail");
    const detailTitle = document.querySelector(".detail-nazov");
    const detailImage = document.querySelector(".detail-obrazok");
    const detailNumber = document.querySelector(".bod-cislo");

    points.forEach(point => {
        point.addEventListener("mouseenter", function () {
            const pointId = this.getAttribute("data-point");
            if (!pointId || !window.bodData[pointId]) return;

            detailTitle.textContent = window.bodData[pointId].title;
            detailImage.src = window.bodData[pointId].img;
            detailNumber.textContent = pointId;

            const rect = this.getBoundingClientRect();
            const parentRect = this.closest(".vlastnosti-image").getBoundingClientRect();
            const screenWidth = window.innerWidth;
            const detailBoxWidth = detailBox.offsetWidth;
            let leftOffset = rect.left - parentRect.left + this.offsetWidth + 10;
            let topOffset = rect.top - parentRect.top + this.offsetHeight + 10;

            if (rect.right + detailBoxWidth > screenWidth) {
                leftOffset = rect.left - parentRect.left - detailBoxWidth - 10;
            }
            if (rect.bottom + detailBox.offsetHeight > window.innerHeight) {
                topOffset = rect.top - parentRect.top - detailBox.offsetHeight - 10;
            }

            detailBox.style.left = `${leftOffset}px`;
            detailBox.style.top = `${topOffset}px`;
            detailBox.classList.add("visible");
        });

        point.addEventListener("mouseleave", function () {
            detailBox.classList.remove("visible");
        });
    });
});